import { Component } from "@angular/core";
import { PerformanceItemComponent } from "../performance-item/performance-item.component";
import { TranslocoPipe } from "@jsverse/transloco";
import { BasePerformanceItemsComponent } from "../base-performance-items/base-performance-items.components";

@Component({
  selector: "er-fuel-performance-items",
  templateUrl: "./fuel-performance-items.component.html",
  standalone: true,
  imports: [PerformanceItemComponent, TranslocoPipe],
})
export class FuelPerformanceItemsComponent extends BasePerformanceItemsComponent {}
